export default "__VITE_ASSET__4c410803__"